
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.492 10.013a2 2 0 000-2.829L5.37 5.063a2 2 0 00-2.828 0L1.378 6.227A3 3 0 001 10a46.5 46.5 0 0013 13 3 3 0 003.773-.379l1.165-1.164a2 2 0 000-2.828l-2.122-2.121a2 2 0 00-2.828 0l-.707.707a47.423 47.423 0 01-6.5-6.5l.711-.702zM12 .5A11.5 11.5 0 0123.5 12","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12 4.5a7.5 7.5 0 017.5 7.5M12 8.5a3.5 3.5 0 013.5 3.5","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    